// extracted by mini-css-extract-plugin
module.exports = {"para":"index-module__para___ZYzGz","arrow":"index-module__arrow___TAut-","arrow_cont":"index-module__arrow_cont___GVPLX"};